import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const ProjectsCarousel = () => {
  const [imageUrls, setImageUrls] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadManifest = async () => {
      try {
        const response = await fetch('/assets/projects/manifest.json', { cache: 'no-store' });
        if (!response.ok) {
          throw new Error(`Failed to load manifest: ${response.status}`);
        }
        const files = await response.json();
        const allowedExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.gif'];
        const urls = files
          .filter((name) => allowedExtensions.some((ext) => name.toLowerCase().endsWith(ext)))
          .map((name) => `/assets/projects/${name}`);
        setImageUrls(urls);
      } catch (e) {
        setError(e.message || 'Failed to load images');
      } finally {
        setIsLoading(false);
      }
    };

    loadManifest();
  }, []);

  if (isLoading) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '20px 0' }}>
        Loading gallery...
      </div>
    );
  }

  if (error) {
    return (
      <div className="container" style={{ color: '#b00020', textAlign: 'center', padding: '20px 0' }}>
        {error}
      </div>
    );
  }

  if (!imageUrls.length) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '20px 0' }}>
        No displayable images found.
      </div>
    );
  }

  return (
    <div className="container">
      <Swiper
        modules={[Navigation, Pagination, Keyboard, Mousewheel]}
        navigation
        pagination={{ clickable: true }}
        keyboard={{ enabled: true }}
        mousewheel={{ forceToAxis: true }}
        loop
        spaceBetween={16}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        }}
        style={{ paddingBottom: 30 }}
      >
        {imageUrls.map((src, idx) => (
          <SwiperSlide key={idx}>
            <div className="work-card">
              <div className="work-image">
                <img src={src} alt={`Project ${idx + 1}`} loading="eager" />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ProjectsCarousel; 